// this is an autogenerated file from DesignSystem/LeadPreview/Content/MiscStats/Location/No/LocationChooser/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_LeadPreview_Content_MiscStats_Location_No_LocationChooser{
  session_user_locations(order_by: { name: asc }) {
    _id
    text: name
  }
}

`